import { UsuarioModel } from './../usuario/usuario.model';
export class IndiceReajusteModel {
    id: number;
    indice: number;
    usuario: UsuarioModel;
}



// WEBPACK FOOTER //
// /app/src/app/model/cliente/indicereajuste.model.ts